<template>
  <div>
    <vx-card class="mb-4">
      <SearchYear
        label="실시내역"
        :query="{ y: 'year' }"
        :options="{
          default: new Date().getFullYear(),
          afterFix: '년',
        }"
        v-model="selectedYear"
      />
    </vx-card>
    <div class="flex items-center justify-end mb-4">
      <vs-button color="secondary" type="border" @click="onClickExcelDownload">Excel 다운로드</vs-button>
    </div>
    <table>
      <colgroup>
        <col width="200" />
      </colgroup>
      <thead>
        <tr>
          <th>구분</th>
          <th v-for="_ in 12" :key="`month-${_}`">{{ _ }}월</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in datas" :key="item.label">
          <td>{{ item.label }}</td>
          <td v-for="(_, _i) in item.data" :key="`${item.label}-${_i}`">
            <div class="flex items-center justify-center">
              <div class="circle" :class="_ ? 'green' : ''"></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import SearchYear from "@/views/list/components/SearchYear.vue";
import XLSX from "xlsx";

export default {
  components: { SearchYear },
  data() {
    return {
      selectedYear: "", // 초기 선택된 연도를 현재 연도로 설정
      datas: {},
    };
  },
  watch: {
    selectedYear(value) {
      this.checkMonth();
    },
  },
  created() {
    this.checkMonth();
  },
  methods: {
    onClickExcelDownload() {
      // 새로운 워크북 생성
      const wb = XLSX.utils.book_new();

      // 데이터를 추가할 워크시트 생성
      const ws_data = [["구분", "1월	", "2월	", "3월	", "4월	", "5월	", "6월	", "7월	", "8월	", "9월	", "10월", "11월", "12월"]];

      for (const key in this.datas) {
        const _data = this.datas[key].data.reduce(
          (prev, curr) => {
            return [...prev, curr ? "작성" : "미작성"];
          },
          [this.datas[key].label]
        );
        ws_data.push(_data);
      }

      // 워크시트 데이터 추가
      const ws = XLSX.utils.aoa_to_sheet(ws_data);

      // 워크북에 워크시트 추가
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      // 엑셀 파일 다운로드
      XLSX.writeFile(wb, `${this.selectedYear} 설비안전위원회 실시내역.xlsx`);
    },
    async checkMonth() {
      if (!this.selectedYear) return;

      const projectId = this.$route.params.proj_id;
      const boardId = this.$route.params.boardId;
      const page = 1;
      const perPage = 10000;
      const dateTarget = "body.monthDate";
      let dateBegin = `${this.selectedYear}-01-01`;
      let dateEnd = `${this.selectedYear}-12-31`;

      const conditions = [];
      conditions.push({ key: dateTarget, operator: ">=", value: dateBegin });
      conditions.push({ key: dateTarget, operator: "<=", value: dateEnd });

      await this.$store.dispatch("board/LOAD_POST_LIST", { projectId, boardId, page, perPage, conditions });
      const list = this.$store.state.board.postListInfo.data;

      let _datas = {};

      if (0 < list.length) {
        list.map((data) => {
          const filedId = data.field_id;
          const content = JSON.parse(data.post_content);
          if (!_datas[filedId]) {
            _datas[filedId] = {
              label: data.field.field_name,
              data: [false, false, false, false, false, false, false, false, false, false, false, false],
            };
          }
          _datas[filedId].data[Number(content.header.month) - 1] = true;
        });

        this.datas = JSON.parse(JSON.stringify(_datas));
      } else {
        this.datas = {};
      }
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  &,
  th,
  td {
    font-size: 14px;
    text-align: center;
    background: white;
    border: 1px solid #cdcdcd;
    padding: 18px 0;
  }

  th {
    font-weight: 500;
    background: #fafafa;
  }

  td {
    font-weight: 400;
  }
}

.circle {
  width: 10px;
  height: 10px;
  background: #ea5455;
  border-radius: 100%;

  &.green {
    background: #28c76f;
  }
}
</style>
